import { Link } from 'react-router-dom';
import type { AnimeItem } from '@/mocks/anime';

interface AnimeCardProps {
  anime: AnimeItem;
  size?: 'normal' | 'large';
}

export default function AnimeCard({ anime, size = 'normal' }: AnimeCardProps) {
  return (
    <Link
      to={`/article/${anime.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-900 border border-background-800/50 hover:border-primary-500/30 transition-all duration-300"
    >
      <div
        className={`relative overflow-hidden ${
          size === 'large' ? 'aspect-[16/9]' : 'aspect-[2/3]'
        }`}
      >
        <img
          src={anime.coverImage}
          alt={anime.title}
          title={`${anime.title} - 羞羞动漫高清番剧`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>

        <div className="absolute top-3 left-3">
          <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-primary-500/90 text-white whitespace-nowrap">
            {anime.rating}
          </span>
        </div>

        <div className="absolute top-3 right-3">
          <span className={`px-2 py-0.5 text-xs font-medium rounded-md whitespace-nowrap ${
            anime.status === '连载中'
              ? 'bg-accent-500/90 text-background-950'
              : 'bg-background-800/80 text-foreground-300'
          }`}>
            {anime.status}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          <h3 className="text-foreground-50 font-heading font-semibold text-sm md:text-base mb-1 line-clamp-1">
            {anime.title}
          </h3>
          <p className="text-foreground-400 text-xs line-clamp-2 mb-2">
            {anime.description}
          </p>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-film-line text-xs"></i>
              共{anime.episodes}集
            </span>
            <span className="text-foreground-700">·</span>
            <span>{anime.releaseYear}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}